// File: src/store/index.ts

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import languageReducer from './slices/languageSlice';
import pendingOrdersReducer from './slices/pendingOrdersSlice';
import failedActionsReducer from '../features/notifications/failedActionsSlice';
import activeLocationReducer from './slices/activeLocationSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        language: languageReducer,
        pendingOrders: pendingOrdersReducer,
        activeLocation: activeLocationReducer,
        failedActions: failedActionsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
